export interface FlipRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

const px = (value: number) => `${Math.round(value * 100) / 100}px`;
const scale = (value: number) => `${Math.round(value * 100000) / 100000}`;

export const buildFlipKeyframes = (from: FlipRect, to: FlipRect): Keyframe[] => {
  const deltaX = from.left - to.left;
  const deltaY = from.top - to.top;
  const scaleX = to.width > 0 ? from.width / to.width : 1;
  const scaleY = to.height > 0 ? from.height / to.height : 1;

  return [
    {
      transform: `translate3d(${px(deltaX)}, ${px(deltaY)}, 0) scale(${scale(scaleX)}, ${scale(scaleY)})`,
    },
    {
      transform: "translate3d(0px, 0px, 0) scale(1, 1)",
    },
  ];
};

export const hasVisibleFlip = (from: FlipRect, to: FlipRect) =>
  Math.abs(from.left - to.left) > 0.5 ||
  Math.abs(from.top - to.top) > 0.5 ||
  Math.abs(from.width - to.width) > 0.5 ||
  Math.abs(from.height - to.height) > 0.5;
